import Carousel from '@/common/Carousel/Carousel';
import type { SemInventoryModuleSectionContent } from '~/contracts/sem';
import useCarouselSettings from '~/hooks/sem/useCarouselSettings';
import ContentTile from './ContentTile';
import VehicleTile from './VehicleTile';

const MAX_TILES = 12;

function InventoryCarousel({
  subtitle,
  title: sectionTitle,
  inventory,
  viewAllLink,
  viewAllLinkText,
  viewMoreTileText
}: SemInventoryModuleSectionContent) {
  const { values, carouselRef } = useCarouselSettings({
    heading: sectionTitle ?? '',
    subHeading: subtitle ?? '',
    maxLength: (inventory?.slice(0, MAX_TILES).length ?? 0) + 1,
    className: 'mb-24 mt-16 sem-inventory-slider',
    viewLinkText: viewAllLinkText ?? '',
    viewLinkUrl: viewAllLink ?? ''
  });

  return (
    <Carousel {...values} ref={carouselRef}>
      {inventory?.slice(0, MAX_TILES).map(vehicle => {
        return vehicle?.linkUrl ? (
          <a
            href={vehicle.linkUrl}
            key={vehicle.title}
            data-analytics-id="Inventory - Vehicle Tile"
            data-analytics-attributes={JSON.stringify({
              title: vehicle.title,
              linkUrl: vehicle.linkUrl
            })}
            className="inline-block !w-fit no-underline"
          >
            <VehicleTile {...vehicle} />
          </a>
        ) : null;
      })}
      <ContentTile
        viewMoreTileText={viewMoreTileText}
        viewAllLink={viewAllLink}
      />
    </Carousel>
  );
}

export default InventoryCarousel;
